import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "form-row" }
const _hoisted_2 = { class: "form-row" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { id: "authorizenet-element-errors" }

import { getCreditCardIssuer } from "@/builder/BuilderUtilities";
import ValidatedInput from "@/builder/components/input/ValidatedInput.vue";
import { FieldStyle, PartialDisplayType } from "@/builder/enums";
import { PageDesign } from "@/builder/interfaces/";
import { useRenderStore } from "@/builder/stores/renderStore";
import RadioButton from "@/components/shared/form/radio/RadioButton.vue";
import { MerchantType, PaymentMethodType, PaymentMethod } from "@/enums";
import { vMaska } from "maska/vue";
import { computed, onBeforeUnmount, onMounted, PropType, ref, watch } from "vue";
import { IPaymentComponent } from "./PaymentInterface";

// injects

export default /*@__PURE__*/_defineComponent({
  __name: 'AuthNetPaymentComponent',
  props: {
    component: {
        type: Object as PropType<IPaymentComponent>,
        required: true,
    },
    organizationId: {
        type: Number as PropType<number | null>,
        required: true,
        default: null,
    },
    merchantAccount: {
        type: String,
        required: true,
    },
    tokenizationKey: {
        type: String,
        required: true,
    },
    readOnly: {
        type: Boolean,
        required: true,
        default: false,
    },
    pageDesign: {
        type: Object as PropType<PageDesign>,
        required: true,
    },
    formIsOnParentStep: Boolean,
},
  setup(__props) {

const renderStore = useRenderStore();

const fieldStyle = computed(() => {
    return props.pageDesign.fieldStyle;
});

// props
const props = __props;

// refs
const isAuthNet = ref(
    renderStore.page.merchantType == MerchantType.AuthorizeNet
);
const scriptLoaded = ref(false);

// computed
const testMode = computed(
    () => renderStore.environment !== "production" || renderStore.isTestMode
);

const accountTypes: Array<{ name: string; value: string }> = [
    {
        name: "Checking",
        value: "checking",
    },
    {
        name: "Savings",
        value: "savings",
    },
    {
        name: "Business Checking",
        value: "businessChecking",
    },
];

const isModalDisplay = computed(() => {
    return renderStore.page.partialDisplayType === PartialDisplayType.Modal;
})

onMounted(async () => {
    loadAuthNetScript();

    if (!renderStore.gift.paymentMethodType)
        renderStore.gift.paymentMethodType = PaymentMethodType.Credit;
});

onBeforeUnmount(() => {
    //remove stripe script
    const script = document.getElementById("authnet-js");
    if (script) {
        script.remove();
    }

    //find stripe script via src
    const scriptUrl = testMode.value
        ? "https://jstest.authorize.net/v1/Accept.js"
        : "https://js.authorize.net/v1/Accept.js";
    const scriptSrc = document.querySelector(`script[src="${scriptUrl}"]`);
    if (scriptSrc) {
        scriptSrc.remove();
    }

    scriptLoaded.value = false;
});

const loadAuthNetScript = () => {
    if (!props.formIsOnParentStep && !props.readOnly) return;
    if (!isAuthNet.value) return;
    if (typeof window === "undefined") return;
    const scriptUrl = testMode.value
        ? "https://jstest.authorize.net/v1/Accept.js"
        : "https://js.authorize.net/v1/Accept.js";

    const script = document.createElement("script");
    script.id = "authnet-js";
    script.src = scriptUrl;
    script.async = true;
    script.defer = true;
    script.onload = () => {
        scriptLoaded.value = true;
    };
    document.head.appendChild(script);
};

const cardNumberChanged = async () => {
    await renderStore.tokenizePaymentMethod();
    renderStore.gift.creditCardType = getCreditCardIssuer(
        renderStore.anetPayment.cardNumber
    );
};

const paymentMethodTypeChanged = () => {
    renderStore.anetPayment = {
        accountNumber: "",
        accountType: "",
        cardCode: "",
        cardNumber: "",
        expDate: "",
        routingNumber: "",
    };
};

watch(
    () => props.formIsOnParentStep,
    async (newVal) => {
        loadAuthNetScript();
    }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["form-radio-group rd-inline-flex rd-leading-none", isModalDisplay.value ? 'rd-mb-1.5' : 'rd-mb-3.5'])
    }, [
      _createVNode(RadioButton, {
        id: "creditCard",
        selected: _unref(renderStore).gift.paymentMethodType === _unref(PaymentMethodType).Credit,
        value: _unref(PaymentMethodType).Credit,
        name: "creditCard",
        modelValue: _unref(renderStore).gift.paymentMethodType,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((_unref(renderStore).gift.paymentMethodType) = $event)),
          paymentMethodTypeChanged
        ],
        labelText: "<i class='rd-mr-1.5 fa-solid fa-credit-card'></i> Card",
        "label-classes": "rd-items-center rd-inline-flex rd-leading-none",
        "is-admin": false,
        "is-inline": true
      }, null, 8, ["selected", "value", "modelValue"]),
      (props.component.customData.paymentMethods.includes(_unref(PaymentMethod).US_Bank_Account))
        ? (_openBlock(), _createBlock(RadioButton, {
            key: 0,
            id: "ach",
            selected: _unref(renderStore).gift.paymentMethodType === _unref(PaymentMethodType).ACH,
            value: _unref(PaymentMethodType).ACH,
            name: "ach",
            modelValue: _unref(renderStore).gift.paymentMethodType,
            "onUpdate:modelValue": [
              _cache[1] || (_cache[1] = ($event: any) => ((_unref(renderStore).gift.paymentMethodType) = $event)),
              paymentMethodTypeChanged
            ],
            labelText: "<i class='rd-mr-1.5 fa-solid fa-building-columns'></i> US Bank Account",
            "label-classes": "rd-items-center rd-inline-flex rd-leading-none",
            "is-admin": false,
            "is-inline": true,
            class: "rd-ml-5"
          }, null, 8, ["selected", "value", "modelValue"]))
        : _createCommentVNode("", true)
    ], 2),
    (_unref(renderStore).gift.paymentMethodType === _unref(PaymentMethodType).Credit)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass({ 'fields-compact': fieldStyle.value == _unref(FieldStyle).Compact })
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(ValidatedInput, {
              id: "cardNumber",
              value: _unref(renderStore).anetPayment.cardNumber,
              label: "Card number",
              "label-for": "cardNumber",
              name: "cardNumber",
              class: "rd-w-full",
              isRequired: true
            }, {
              input: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  id: "cardNumber",
                  name: "cardNumber",
                  type: "text",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(renderStore).anetPayment.cardNumber) = $event)),
                  placeholder: "1234 1234 1234 1234",
                  maxLength: 16,
                  onChange: cardNumberChanged,
                  onBlur: cardNumberChanged
                }, null, 544), [
                  [_vModelText, _unref(renderStore).anetPayment.cardNumber]
                ])
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["form-row", [{ 'rd-mt-0 md:rd-gap-x-4 md:rd-mt-4': fieldStyle.value != _unref(FieldStyle).Compact && !isModalDisplay.value },
        { 'rd-mt-0 md:rd-gap-x-4': (fieldStyle.value != _unref(FieldStyle).Compact && isModalDisplay.value) }]])
          }, [
            _createVNode(ValidatedInput, {
              id: "expDate",
              value: _unref(renderStore).anetPayment.expDate,
              label: "Expiration date",
              "label-for": "expDate",
              name: "expDate",
              class: _normalizeClass(["rd-w-full md:rd-flex-equal", [{ 'rd-mt-4 md:rd-mt-0': fieldStyle.value != _unref(FieldStyle).Compact && !isModalDisplay.value },
                { 'rd-mt-2.5': (fieldStyle.value != _unref(FieldStyle).Compact && isModalDisplay.value) }]]),
              isRequired: true
            }, {
              input: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "expDate",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(renderStore).anetPayment.expDate) = $event)),
                  placeholder: "MM/YY",
                  maxLength: 5,
                  "data-maska": "##/##",
                  onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(renderStore).tokenizePaymentMethod && _unref(renderStore).tokenizePaymentMethod(...args))),
                  onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(renderStore).tokenizePaymentMethod && _unref(renderStore).tokenizePaymentMethod(...args)))
                }, null, 544), [
                  [_vModelText, _unref(renderStore).anetPayment.expDate],
                  [_unref(vMaska)]
                ])
              ]),
              _: 1
            }, 8, ["value", "class"]),
            _createVNode(ValidatedInput, {
              id: "cardCode",
              value: _unref(renderStore).anetPayment.cardCode,
              label: "Security code",
              "label-for": "cardCode",
              name: "cardCode",
              class: _normalizeClass(["rd-w-full md:rd-flex-equal", [{ 'rd-mt-4 md:rd-mt-0': fieldStyle.value != _unref(FieldStyle).Compact && !isModalDisplay.value },
                { 'rd-mt-2.5': (fieldStyle.value != _unref(FieldStyle).Compact && isModalDisplay.value) }]]),
              isRequired: true
            }, {
              input: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "cardCode",
                  name: "cardCode",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(renderStore).anetPayment.cardCode) = $event)),
                  placeholder: "CVC",
                  maxLength: 4,
                  onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_unref(renderStore).tokenizePaymentMethod && _unref(renderStore).tokenizePaymentMethod(...args))),
                  onBlur: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_unref(renderStore).tokenizePaymentMethod && _unref(renderStore).tokenizePaymentMethod(...args)))
                }, null, 544), [
                  [_vModelText, _unref(renderStore).anetPayment.cardCode]
                ])
              ]),
              _: 1
            }, 8, ["value", "class"])
          ], 2)
        ], 2))
      : _createCommentVNode("", true),
    (_unref(renderStore).gift.paymentMethodType === _unref(PaymentMethodType).ACH)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass({ 'fields-compact': fieldStyle.value == _unref(FieldStyle).Compact })
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(ValidatedInput, {
              id: "routingNumber",
              value: _unref(renderStore).anetPayment.routingNumber,
              label: "Routing number",
              name: "routingNumber",
              class: "rd-w-full",
              isRequired: true
            }, {
              input: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(renderStore).anetPayment.routingNumber) = $event)),
                  maxLength: 9,
                  onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_unref(renderStore).tokenizePaymentMethod && _unref(renderStore).tokenizePaymentMethod(...args))),
                  onBlur: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_unref(renderStore).tokenizePaymentMethod && _unref(renderStore).tokenizePaymentMethod(...args)))
                }, null, 544), [
                  [_vModelText, _unref(renderStore).anetPayment.routingNumber]
                ])
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["form-row", [{ 'rd-mt-0 md:rd-gap-x-4 md:rd-mt-4': fieldStyle.value != _unref(FieldStyle).Compact && !isModalDisplay.value },
        { 'rd-mt-0 md:rd-gap-x-4': (fieldStyle.value != _unref(FieldStyle).Compact && isModalDisplay.value) }]])
          }, [
            _createVNode(ValidatedInput, {
              id: "accountNumber",
              value: _unref(renderStore).anetPayment.accountNumber,
              label: "Account number",
              name: "accountNumber",
              class: _normalizeClass(["rd-w-full md:rd-flex-equal", [{ 'rd-mt-4 md:rd-mt-0': fieldStyle.value != _unref(FieldStyle).Compact && !isModalDisplay.value },
                { 'rd-mt-2.5': (fieldStyle.value != _unref(FieldStyle).Compact && isModalDisplay.value) }]]),
              isRequired: true
            }, {
              input: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(renderStore).anetPayment.accountNumber) = $event)),
                  maxLength: 9,
                  onChange: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_unref(renderStore).tokenizePaymentMethod && _unref(renderStore).tokenizePaymentMethod(...args))),
                  onBlur: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_unref(renderStore).tokenizePaymentMethod && _unref(renderStore).tokenizePaymentMethod(...args)))
                }, null, 544), [
                  [_vModelText, _unref(renderStore).anetPayment.accountNumber]
                ])
              ]),
              _: 1
            }, 8, ["value", "class"]),
            _createVNode(ValidatedInput, {
              id: "accountType",
              value: _unref(renderStore).anetPayment.accountType,
              label: "Account Type",
              name: "accountType",
              class: _normalizeClass(["rd-w-full md:rd-flex-equal", [{ 'rd-mt-4 md:rd-mt-0': fieldStyle.value != _unref(FieldStyle).Compact && !isModalDisplay.value },
                { 'rd-mt-2.5': (fieldStyle.value != _unref(FieldStyle).Compact && isModalDisplay.value) }]]),
              isRequired: true
            }, {
              input: _withCtx(() => [
                _withDirectives(_createElementVNode("select", {
                  id: "accountType",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(renderStore).anetPayment.accountType) = $event)),
                  onChange: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_unref(renderStore).tokenizePaymentMethod && _unref(renderStore).tokenizePaymentMethod(...args)))
                }, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(accountTypes, (item) => {
                    return _createElementVNode("option", {
                      key: item.value,
                      value: item.value
                    }, _toDisplayString(item.name), 9, _hoisted_3)
                  }), 64))
                ], 544), [
                  [_vModelSelect, _unref(renderStore).anetPayment.accountType]
                ])
              ]),
              _: 1
            }, 8, ["value", "class"])
          ], 2)
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(renderStore).paymentElementError), 1)
  ], 64))
}
}

})